import { getAbilityModifier } from "./weaponRolls";

const number = (value) => Number(value) || 0;

export function calculateCombatManeuvers(characteristics = {}) {
  const baseAttackModifier = number(characteristics.baseAttackModifier);
  const strengthModifier = getAbilityModifier(characteristics, "strength");
  const dexterityModifier = getAbilityModifier(characteristics, "dexterity");
  const sizeModifier = number(characteristics.combatManeuverSizeModifier);
  const additionalCmbModifier = number(
    characteristics.additionalCombatManeuverBonus
  );
  const additionalCmdModifier = number(
    characteristics.additionalCombatManeuverDefense
  );

  return {
    cmb:
      baseAttackModifier +
      strengthModifier +
      sizeModifier +
      additionalCmbModifier,
    cmd:
      10 +
      baseAttackModifier +
      strengthModifier +
      dexterityModifier +
      sizeModifier +
      additionalCmdModifier,
    baseAttackModifier,
    strengthModifier,
    dexterityModifier,
    sizeModifier,
    additionalCmbModifier,
    additionalCmdModifier,
  };
}
